import {
  GET_ANALYTICS,
  GET_ANALYTICS_SUCCESS,
  GET_ANALYTICS_ERROR,
  RESET_ANALYTICS,
  GET_ANALYTICS_EXPORT,
  GET_ANALYTICS_EXPORT_SUCCESS,
  GET_ANALYTICS_EXPORT_ERROR,
  RESET_ANALYTICS_EXPORT_ERROR,
  GET_CLICK_CONV_AGGR_ANALYTICS,
  GET_CLICK_CONV_AGGR_ANALYTICS_SUCCESS,
  GET_CLICK_CONV_AGGR_ANALYTICS_ERROR,
  GET_ANALYTICS_COMPARE_TO_SUCCESS,
  GET_CLICK_CONV_AGGR_ANALYTICS_COMPARE_TO_SUCCESS,
  RESET_ANALYTICS_COMPARED_TO,
  GET_CALL_OPPORTUNITIES,
  GET_CALL_OPPORTUNITIES_SUCCESS,
  GET_CALL_OPPORTUNITIES_ERROR,
  GET_CALL_OPPORTUNITIES_COMPARE_TO_SUCCESS,
  GET_CALL_OPPORTUNITIES_COMPARE_TO_ERROR,
  GET_CALL_OPPORTUNITIES_COMPARE_TO,
} from "./actionTypes";

let analyticsRequestId = 0;

export const getAnalytics = (analytics, product_type, compare_to) => {
  const request_id = compare_to ? undefined : ++analyticsRequestId;
  return {
    type: GET_ANALYTICS,
    payload: analytics,
    product_type: product_type,
    compare_to: compare_to,
    request_id
  }
}

export const getAnalyticsSuccess = (analytics, total_analytics, pagination = null, request_id = null)  => {
  return {
    type: GET_ANALYTICS_SUCCESS,
    payload: {analytics, total_analytics, pagination},
    request_id
  }
}

export const getAnalyticsError = (error, request_id = null) => {
  return {
    type: GET_ANALYTICS_ERROR,
    payload: error,
    request_id
  }
}

export const resetAnalytics = () => ({
  type: RESET_ANALYTICS,
})

export const getAnalyticsExport = (analytics, product_type) => {
  return {
    type: GET_ANALYTICS_EXPORT,
    payload: analytics,
    product_type: product_type
  }
}

export const getAnalyticsExportSuccess = (response) => {
  return {
    type: GET_ANALYTICS_EXPORT_SUCCESS,
    payload: response
  }
}

export const getAnalyticsExportError = (error) => {
  return {
    type: GET_ANALYTICS_EXPORT_ERROR,
    payload: error,
  }
}

export const resetAnalyticsExportError = () => {
  return {
    type: RESET_ANALYTICS_EXPORT_ERROR
  }
}

export const getClickConvAggrAnalytics = (payload, product_type, compare_to) => {
  return {
    type: GET_CLICK_CONV_AGGR_ANALYTICS,
    payload: payload,
    product_type: product_type,
    compare_to: compare_to
  }
}

export const getClickConvAggrAnalyticsSuccess = (conv_aggr_stats, total_aggr_stats, product_type) => {
  return {
    type: GET_CLICK_CONV_AGGR_ANALYTICS_SUCCESS,
    payload: { conv_aggr_stats, total_aggr_stats },
    product_type: product_type
  }
}

export const getClickConvAggrAnalyticsError = error => {
  return {
    type: GET_CLICK_CONV_AGGR_ANALYTICS_ERROR,
    payload: error,
  }
}

export const getCompareToAnalyticsSuccess = (analytics, total_analytics, pagination = null)  => {
  return {
    type: GET_ANALYTICS_COMPARE_TO_SUCCESS,
    payload: {analytics, total_analytics, pagination},
  }
}

export const getCompareToClickConvAggrAnalyticsSuccess = (conv_aggr_stats, total_aggr_stats, product_type) => {
  return {
    type: GET_CLICK_CONV_AGGR_ANALYTICS_COMPARE_TO_SUCCESS,
    payload: { conv_aggr_stats, total_aggr_stats },
    product_type: product_type
  }
}

export const resetAnalyticsComapareTo = () => {
  return {
    type: RESET_ANALYTICS_COMPARED_TO
  }
}

export const getCallOpportunities = (payload, product_type, compare_to) => {
  return {
    type: GET_CALL_OPPORTUNITIES,
    payload: payload,
    product_type: product_type,
    compare_to: compare_to
  }
}

export const getCallOpportunitiesSuccess = (analytics, total_analytics) => {
  return {
    type: GET_CALL_OPPORTUNITIES_SUCCESS,
    payload: {analytics, total_analytics},
  }
}

export const getCallOpportunitiesError = error => {
  return {
    type: GET_CALL_OPPORTUNITIES_ERROR,
    payload: error,
  }
}

export const getCompareToCallOpportunities = (payload, product_type, compare_to) => {
  return {
    type: GET_CALL_OPPORTUNITIES_COMPARE_TO,
    payload: payload,
    product_type: product_type,
    compare_to: compare_to
  }
}

export const getCompareToCallOpportunitiesSuccess = (analytics, total_analytics) => {
  return {
    type: GET_CALL_OPPORTUNITIES_COMPARE_TO_SUCCESS,
    payload: {analytics, total_analytics},
  }
}

export const getCompareToCallOpportunitiesError = error => {
  return {
    type: GET_CALL_OPPORTUNITIES_COMPARE_TO_ERROR,
    payload: error,
  }
}
